const List = () => import("~/components/Views/Prova/ConsultarProva/List");
const DesempenhoGrupoAvaliacao = () =>
  import("~/components/Views/Prova/ConsultarProva/DesempenhoGrupoAvaliacao");
const Desempenho = () =>
  import("~/components/Views/Prova/ConsultarProva/Desempenho");

import auth from "~/middleware/auth";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Alunos", link: "" }
];

export const minhasProvas = [
  {
    path: "alunos/minhas-provas",
    component: List,
    name: "Minhas Provas",
    meta: {
      title: "Minhas Provas",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "consulta/view/desempenho/grupoAvaliacao/:aplicacaoProvaId/:alunoId",
    component: DesempenhoGrupoAvaliacao,
    name: "Visualizar Desempenho",
    meta: {
      title: "Desempenho",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "consulta/view/desempenho/:alunoId/:provaId/:aplicacaoProvaId",
    component: Desempenho,
    name: "Visualizar Desempenho",
    meta: {
      title: "Desempenho",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/alunos/minhasProvas.js